import React, { useEffect, useState } from 'react'
import {
  Form,
  Input,
  Button,
  Card,
  Row,
  Col,
  Space,
  Progress,
  Checkbox,
  Upload,
  message,
  Modal,
  Alert
} from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import minijust_logo from '../../assets/img/minijust_logo.png'
import { PHONE_PATTERN } from '../../constants/general'
import InstitutionUserService from '../../services/InstitutionUserService'
import { useParams, useLocation } from 'react-router-dom'
import moment from 'moment'
import { type UploadChangeParam } from 'antd/es/upload'
import { v4 as uuidv4 } from 'uuid'

/**
 * Detail view field order for lists/modals: see `bailiffRefundRequestDetailConfig.ts`.
 */
const BAILIFF_REFUND_FIXED_BENEFICIARY = {
  bank_code: '040',
  beneficiary_account_number: '100250096687',
  beneficiary_bank_name: 'Bank of Kigali Plc',
  beneficiary_bank_account_name: 'PBA/IRANGIZWA RY INYANDIKOMPESHA'
} as const

const BaillifRefundRequest: React.FC = () => {
  const [form] = Form.useForm()
  const [currentStep, setCurrentStep] = useState(1)
  const [fullName, setBidderFullName] = useState('')
  const [phone_number, setPhoneNumber] = useState('')
  const [bailiffEmail, setBailiffEmail] = useState('')
  const [payment_date, setPaymentDate] = useState('')
  const [loadingRefund, setLoadingRefund] = useState(false)
  const [declarationChecked, setDeclarationChecked] = useState(false)
  const { ref_number } = useParams()
  const [codeBank, setBankCode] = useState()
  const location = useLocation()
  const [loading, setLoading] = useState(false)
  const [showOTPForm, setShowOTPForm] = useState(false)
  const [countdown, setCountdown] = useState(300000)
  const [isFormValidated, setIsFormValidated] = useState(true)
  const [isFormSubmitted, setIsFormSubmitted] = useState(false)
  const [transactionReference, setBailiffTransactionReferenceNumber] = useState('')
  // const [transactionReference, setTransactionReference] = useState(false)
  const [bidderBidReferenceNumber, setReferenceNumber] = useState<string>('')
  const [showBankTransferChargeModal, setShowBankTransferChargeModal] = useState(false)
  const [otpValue, setOtpValue] = useState('')
  const [otpDigits, setOtpDigits] = useState<string[]>(['', '', '', '', '', ''])
  const [otpError, setOtpError] = useState('')
  const [respStatus, setRespStatus] = useState('0')
  const [messages, setMessage] = useState('')
  const [token, setToken] = useState('')
  const [isEdit, setIsEdit] = useState(false)
  const [showDeclarationAlert, setShowDeclarationAlert] = useState(false)
  const [showWarningAlert, setShowWarningAlert] = useState(false)
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)
  const [showWarningAlert2, setShowWarningAlert2] = useState(false)
  const [targetPaymentDateValue, setTargetPaymentDateValue] = useState(false)
  const [showCancelMessage, setShowCancelMessage] = useState(false)
  const [showForm, setShowForm] = useState(false)
  const [paymentAmount, setPaymentAmount] = useState('')
  const [bailiffId, setBailiffId] = useState('')
  const [refundableAmount, setRefundableAmount] = useState('0')
  const [showBankCodeModal, setShowBankCodeModal] = useState(false)
  const [showHello, setShowHello] = useState(true)
  const [fileList, setFileList] = useState<any[]>([])
  const [isVisible, setIsVisible] = useState(true)
  const steps = [
    { title: 'Details Verification' },
    { title: 'Provide Payment Details' },
    { title: 'Final Step' }
  ]
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleAgree = () => {
    setShowBankTransferChargeModal(false)
    setShowForm(true)
  }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const nextStep = () => {
    setCurrentStep(currentStep + 1)
  }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const prevStep = () => {
    setCurrentStep(currentStep - 1)
  }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleFileChange = (info: UploadChangeParam<any>) => {
    const selectedFile = info.fileList[0]?.originFileObj as File | undefined
    const maxAttachmentSizeBytes = 5 * 1024 * 1024
    if (selectedFile != null) {
      const isPdfFile =
        selectedFile.type === 'application/pdf' ||
        selectedFile.name.toLowerCase().endsWith('.pdf')
      if (!isPdfFile) {
        void message.error('Only PDF files are allowed.')
        setFileList([])
        return
      }
      if (selectedFile.size > maxAttachmentSizeBytes) {
        void message.error('Attachment is too large. Maximum allowed size is 5MB.')
        setFileList([])
        return
      }
    }
    setFileList(info.fileList.slice(-1))
  }

  const getFriendlyBailiffUploadErrorMessage = (error: unknown): string => {
    const errorRecord: Record<string, unknown> =
      (typeof error === 'object' && error !== null) ? (error as Record<string, unknown>) : {}
    const responseRecord: Record<string, unknown> =
      (typeof errorRecord.response === 'object' && errorRecord.response !== null)
        ? (errorRecord.response as Record<string, unknown>)
        : {}
    const responseData: Record<string, unknown> =
      (typeof responseRecord.data === 'object' && responseRecord.data !== null)
        ? (responseRecord.data as Record<string, unknown>)
        : {}
    const serverMessage: string =
      (typeof responseData.message === 'string')
        ? responseData.message
        : ''
    const rawErrorCode: string =
      (typeof responseData.error === 'string')
        ? responseData.error.toLowerCase()
        : ''
    const normalizedServerMessage = serverMessage.toLowerCase()
    const normalizedAxiosMessage =
      (typeof errorRecord.message === 'string') ? errorRecord.message.toLowerCase() : ''

    if (
      normalizedServerMessage.includes('only valid pdf files are allowed') ||
      normalizedServerMessage.includes('invalid pdf')
    ) {
      return 'Invalid file format. Please upload a valid PDF document.'
    }

    if (
      normalizedServerMessage.includes('attachment is required') ||
      normalizedServerMessage.includes('please upload a required document')
    ) {
      return 'Please attach your bank slip PDF before submitting.'
    }

    if (
      rawErrorCode.includes('limit_file_size') ||
      normalizedServerMessage.includes('file too large') ||
      normalizedAxiosMessage.includes('file too large')
    ) {
      return 'Attachment is too large. Maximum allowed size is 5MB.'
    }

    return (serverMessage !== '')
      ? serverMessage
      : 'Failed to upload attachment. Please use a valid PDF file (max 5MB).'
  }
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOtpValue(e.target.value)
  }

  // OTP input handlers for better UX
  const handleOtpChange = (index: number, value: string): void => {
    if (!/^[0-9]?$/.test(value)) { return }
    const next = [...otpDigits]
    next[index] = value
    setOtpDigits(next)
    setOtpValue(next.join(''))
    setOtpError('')
    const nextInput = document.getElementById(`otp-input-bailiff-${index + 1}`) as HTMLInputElement | null
    if (value !== '' && nextInput !== null) { nextInput.focus() }
  }

  const handleOtpKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === 'Backspace' && otpDigits[index] === '') {
      const prevInput = document.getElementById(`otp-input-bailiff-${index - 1}`) as HTMLInputElement | null
      if (prevInput !== null) { prevInput.focus() }
    }
  }

  const handleOtpPaste = (e: React.ClipboardEvent<HTMLInputElement>): void => {
    e.preventDefault()
    const text = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6)
    if (text.length === 0) { return }
    const filled = Array.from({ length: 6 }, (_, i) => text[i] ?? '')
    setOtpDigits(filled)
    setOtpValue(filled.join(''))
    setOtpError('')
    const lastIndex = Math.min(text.length, 6) - 1
    const nextInput = document.getElementById(`otp-input-bailiff-${lastIndex}`) as HTMLInputElement | null
    if (nextInput !== null) { nextInput.focus() }
  }

  // Handle Resend OTP
  const handleResendOTP = async (): Promise<void> => {
    try {
      setOtpError('')
      setOtpDigits(['', '', '', '', '', ''])
      setOtpValue('')
      setCountdown(300000)
      const otpResponse = await InstitutionUserService.bailiffCreateOtpCode({
        transaction_reference: bidderBidReferenceNumber,
        status: 'PENDING'
      })
      if (otpResponse.status === 200) {
        void message.success('OTP has been resent to your phone number.')
        const firstInput = document.getElementById('otp-input-bailiff-0') as HTMLInputElement | null
        if (firstInput !== null) {
          firstInput.focus()
        }
      } else {
        void message.error('Failed to resend OTP. Please try again.')
      }
    } catch (error) {
      void message.error('Failed to resend OTP. Please try again.')
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOTPFormCancel = () => {
    setShowOTPForm(false)
    setOtpDigits(['', '', '', '', '', ''])
    setOtpValue('')
    setOtpError('')
  }
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false)
    }, 3000)

    return () => {
      clearTimeout(timer)
    }
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHello(false)
    }, 30 * 1000) // 30 sec = 30000 ms

    return () => { clearTimeout(timer) }
  }, [])

  useEffect(() => {
    // eslint-disable-next-line no-console
  }, [ref_number])
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const handleOTPSubmit = async () => {
    const otp = (otpDigits.join('') !== '' ? otpDigits.join('') : otpValue)
    if (otp.length !== 6) {
      setOtpError('Please enter the complete 6-digit OTP code')
      setLoadingRefund(false)
      return
    }
    setOtpError('')
    setLoadingRefund(true)

    try {
      // Validate transaction reference
      if (bidderBidReferenceNumber === '' || bidderBidReferenceNumber == null) {
        setOtpError('Transaction reference is missing. Please refresh the page.')
        setLoadingRefund(false)
        void message.error('Transaction reference is missing. Please refresh the page.')
        return
      }

      // Verify OTP
      const payloadForVerifyOTP = {
        transaction_reference: bidderBidReferenceNumber,
        otp
      }

      const verifyResponse = await InstitutionUserService.bailiffVerifyOtpToSendRequest(payloadForVerifyOTP)

      if (verifyResponse.status === 200) {
        // OTP verified successfully, now update status to RECEIVED REQUEST
        const confirmationPayload = {
          transaction_reference: form.getFieldValue('bidSecurityReference'),
          status: 'RECEIVED REQUEST'
        }

        const confResponse = await InstitutionUserService.BailiffRefundRequestConfirmation(confirmationPayload)

        if (confResponse.status === 200) {
          setShowOTPForm(false)
          setOtpDigits(['', '', '', '', '', ''])
          setOtpValue('')
          setShowSuccessAlert(true)
          form.resetFields()
          setLoadingRefund(false)
        } else {
          void message.warning('OTP verified, but failed to update status. Contact Us on iecms-support@minijust.gov.rw')
          setLoadingRefund(false)
        }
      } else {
        setOtpError('OTP verification failed. Please try again.')
        setOtpDigits(['', '', '', '', '', ''])
        setOtpValue('')
        setLoadingRefund(false)
        const firstInput = document.getElementById('otp-input-bailiff-0') as HTMLInputElement | null
        if (firstInput !== null) {
          firstInput.focus()
        }
        void message.error('OTP verification failed. Please try again.')
      }
    } catch (error: any) {
      // eslint-disable-next-line no-console
      console.error('OTP verification error:', error)

      if (error?.response != null) {
        const status = error.response.status
        const errorData = error.response.data

        if (status === 400) {
          setOtpError((errorData?.message != null) ? String(errorData.message) : 'Invalid OTP code. Please try again.')
          setOtpDigits(['', '', '', '', '', ''])
          setOtpValue('')
          const firstInput = document.getElementById('otp-input-bailiff-0') as HTMLInputElement | null
          if (firstInput !== null) {
            firstInput.focus()
          }
          void message.error((errorData?.message != null) ? String(errorData.message) : 'Invalid OTP code. Please try again.')
        } else if (status === 404) {
          setOtpError('OTP not found or expired. Please request a new OTP.')
          void message.error('OTP not found or expired. Please request a new OTP.')
        } else if (status === 500) {
          setOtpError('Server error occurred. Please try again later.')
          void message.error('Server error occurred. Please try again later.')
        } else {
          const errorMessage = (errorData?.message != null) ? String(errorData.message) : 'An error occurred while processing your request'
          setOtpError(errorMessage)
          void message.error(errorMessage)
        }
      } else if (error?.message === 'Network Error' || error?.code === 'ECONNABORTED') {
        setOtpError('Network error. Please check your internet connection and try again.')
        void message.error('Network error. Please check your internet connection and try again.')
      } else {
        setOtpError('An error occurred. Please try again.')
        void message.error('An error occurred while processing your request')
      }
      setLoadingRefund(false)
    }
  }
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHello(true)
    }, 20000) // 20 seconds
    return () => {
      clearTimeout(timer)
    }
  }, [])
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown === 0) {
          clearInterval(timer)
          return 0
        }
        return prevCountdown - 1000
      })
    }, 1000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const fetchData = async () => {
      setLoading(true)
      if (ref_number !== null && ref_number !== undefined) {
        try {
          const params = new URLSearchParams(location.search)
          const prpParam = params.get('prp')
          // eslint-disable-next-line max-len
          const resp = await InstitutionUserService.validateBailiffDetailsOnAuction(
            prpParam,
            ref_number
          )
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          const data = resp.data
          setRespStatus(resp.status)
          setMessage(data.messages)
          setReferenceNumber(data?.bid?.bidSecurityRefNumber)
          setBidderFullName(data?.bidder?.firstName)
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          if (resp && resp.status === 200) {
            form.setFieldsValue({
              // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
              bidder_full_name: `${data?.bidder?.firstName} ${data?.bidder?.lastName}`,
              bidder_national_id_number: data?.bidder?.idNumberTin,
              phone_number: data?.bidder?.telephone,
              // eslint-disable-next-line max-len,@typescript-eslint/restrict-template-expressions
              bailiff_assigned: `${data?.bailiff?.bailiffFirstName} ${data?.bailiff?.bailiffLastName}`,
              bailiff_national_id_number: data?.bailiff?.bailiffNationalId,
              bailiff_phone_number: data?.bailiff?.bailiffPhoneNumber,
              property_id: data?.bid?.propertyId,
              bidSecurityReference: data?.bid?.bidSecurityRefNumber,
              prp: prpParam,
              execution_case_number: data?.bid?.executionCaseNumber,
              requester: data?.bailiff?.bailiffBankAccountName,
              beneficiary_account_number: BAILIFF_REFUND_FIXED_BENEFICIARY.beneficiary_account_number,
              beneficiary_bank_name: BAILIFF_REFUND_FIXED_BENEFICIARY.beneficiary_bank_name,
              beneficiary_bank_account_name: BAILIFF_REFUND_FIXED_BENEFICIARY.beneficiary_bank_account_name,
              bank_code: BAILIFF_REFUND_FIXED_BENEFICIARY.bank_code
            })
            setBailiffEmail(data?.bailiff?.bailiffEmail)
            setPhoneNumber(data?.bailiff?.bailiffPhoneNumber)
            // eslint-disable-next-line @typescript-eslint/no-shadow,max-len
            void InstitutionUserService.loadWinnerBidderDetailsForRefund(
              data?.bid?.bidSecurityRefNumber
            ).then((res: any) => {
              // eslint-disable-next-line @typescript-eslint/no-shadow
              const data = res.data
              let amountValue = parseInt(String(data?.payment.amount)).toLocaleString()
              if (codeBank !== '040') {
                amountValue = (parseInt(String(data?.payment.amount)) - 1000).toLocaleString()
              }
              form.setFieldsValue({
                // transaction_reference: data.ref_number,
                amount: parseInt(String(data?.payment.amount)).toLocaleString(),
                transaction_currency: data?.payment.currency,
                property_id: data.bid?.auction.property_id,
                bidder_national_id_number: data?.bid?.bidder.nid,
                bidder_id: data?.bid?.bidder.bidder_id,
                bid_security_id: data?.payment.bid_security_id,
                bid_payment_date: data?.payment.payment_date,
                refundable_bid_security_amount: amountValue
              })
              setPaymentDate(data?.payment.payment_date)
              setPaymentAmount(data?.payment.amount)
            })
          } else {
            // eslint-disable-next-line no-console
            console.error('Failed To Fetch Data. Server Returned Status:', resp.status)
            void message.error('Failed To Fetch Data. Server returned status:', resp.status)
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Unhandled error:', error)
          setShowBankTransferChargeModal(false)
          // void message.error('Failed To Load Data. Contact Us on iecms-support@minijust.gov.rw')
          setShowCancelMessage(false)
        } finally {
          setLoading(false)
        }
      } else {
        // eslint-disable-next-line no-console
        console.error('Ref number is null or undefined')
        setShowBankTransferChargeModal(false)
        void message.error('Failed To Load Data. Reference number is missing.')
        setShowCancelMessage(false)
      }
    }

    void fetchData()
  }, [ref_number, form, location.search, codeBank, bidderBidReferenceNumber])

  useEffect(() => {
    const bankCode = form.getFieldValue('bank_code')
    setBankCode(bankCode)
    // eslint-disable-next-line no-console
    if (bankCode !== '040') {
      if (bankCode !== null && bankCode !== undefined && bankCode !== '') {
        setShowBankTransferChargeModal(true)
        setShowBankCodeModal(false)
        setShowCancelMessage(false)
        const bailiffRefundableAmount = Number(paymentAmount) - 1000
        setRefundableAmount(bailiffRefundableAmount.toString())
      } else {
        setShowBankTransferChargeModal(false)
        setShowBankCodeModal(true)
      }
    } else {
      if (bankCode !== null && bankCode !== undefined && bankCode !== '') {
        setShowBankTransferChargeModal(true)
        setShowBankCodeModal(false)
        setShowCancelMessage(false)
        setRefundableAmount(paymentAmount)
      } else {
        setShowBankTransferChargeModal(false)
        setShowBankCodeModal(true)
      }
    }
  }, [form, paymentAmount])

  const onFinish = async (values: any): Promise<void> => {
    setLoadingRefund(true)
    setIsFormSubmitted(true)

    const paymentDate = moment(payment_date, 'YYYY-MM-DD HH:mm:ss')
    const targetPaymentDate = moment('2024-07-25', 'YYYY-MM-DD')
    const modifiedTargetPaymentDate = targetPaymentDate.format('YYYY-MM-DD')

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    setTargetPaymentDateValue(modifiedTargetPaymentDate)

    if (!paymentDate.isValid()) {
      setLoadingRefund(false)
      void message.warning(
        `Invalid payment date format: ${paymentDate.format('YYYY-MM-DD HH:mm:ss')}.`
      )
      return
    }

    if (!paymentDate.isSameOrAfter(targetPaymentDate)) {
      setLoadingRefund(false)
      setShowWarningAlert2(true)
      return
    }

    if (!declarationChecked) {
      setLoadingRefund(false)
      setShowDeclarationAlert(true)
      return
    }

    try {
      await form.validateFields()
      setIsFormValidated(true)

      const amount = form.getFieldValue('amount')?.replace(/,/g, '')
      const file = fileList[0]?.originFileObj

      const bailiffRequesterName = String(form.getFieldValue('bailiff_assigned') ?? '').trim()
      const bailiffRequesterNid = String(form.getFieldValue('bailiff_national_id_number') ?? '').trim()
      const fallbackRequesterLabel = String(form.getFieldValue('requester') ?? '').trim()
      const requesterInReason =
        bailiffRequesterName !== ''
          ? (bailiffRequesterNid !== '' ? `${bailiffRequesterName} (NID ${bailiffRequesterNid})` : bailiffRequesterName)
          : (fallbackRequesterLabel !== '' ? fallbackRequesterLabel : 'Unknown bailiff requester')

      if (file === undefined || file === null) {
        setLoadingRefund(false)
        void message.error('Please upload a required document.')
        return
      }

      // Check if refund request already exists
      const bodyParam = {
        transaction_reference: form.getFieldValue('bidSecurityReference')
      }

      try {
        const refundRequestResponse: any =
          await InstitutionUserService.getBailiffDataByTransactionReference(bodyParam)

        if (refundRequestResponse?.status === 200) {
          setShowWarningAlert(true)
          setShowOTPForm(false)
          setLoadingRefund(false)
          return
        }
      } catch (error: any) {
        // 404 means request does not exist; continue with create flow.
        if (error?.response?.status !== 404) {
          // eslint-disable-next-line no-console
          console.error('Failed to validate existing bailiff refund request:', error)
          setLoadingRefund(false)
          void message.error('Failed to validate existing request. Please try again.')
          return
        }
      }

      // Prepare FormData for creating refund request
      const formData = new FormData()
      const txRef = String(form.getFieldValue('bidSecurityReference') ?? '')

      if (txRef === '') {
        setLoadingRefund(false)
        void message.error('Transaction reference is required. Please refresh the page and try again.')
        return
      }

      // Always reload IDs from source-of-truth API before submit to avoid stale/mismatched pair.
      let verifiedBidderId = String(form.getFieldValue('bidder_id') ?? '')
      let verifiedBidSecurityId = String(form.getFieldValue('bid_security_id') ?? '')
      try {
        // Primary source used by bidder refund flow.
        const detailsResp: any = await InstitutionUserService.loadBidsDetailsForRefund(txRef)
        const primaryBidderId = detailsResp?.data?.bid?.bidder?.bidder_id
        const primaryBidSecurityId = detailsResp?.data?.payment?.bid_security_id

        // Fallback source used by bailiff flow.
        const winnerResp: any = await InstitutionUserService.loadWinnerBidderDetailsForRefund(txRef)
        const fallbackBidderId = winnerResp?.data?.bid?.bidder?.bidder_id
        const fallbackBidSecurityId = winnerResp?.data?.payment?.bid_security_id

        const latestBidderId = primaryBidderId ?? fallbackBidderId
        const latestBidSecurityId = primaryBidSecurityId ?? fallbackBidSecurityId

        if (latestBidderId == null || latestBidSecurityId == null) {
          setLoadingRefund(false)
          void message.error('Unable to validate bidder details for this transaction reference.')
          return
        }

        // If both sources exist but disagree, stop and surface a clear error.
        if (
          primaryBidderId != null &&
          primaryBidSecurityId != null &&
          fallbackBidderId != null &&
          fallbackBidSecurityId != null &&
          (String(primaryBidderId) !== String(fallbackBidderId) ||
            String(primaryBidSecurityId) !== String(fallbackBidSecurityId))
        ) {
          setLoadingRefund(false)
          void message.error('Data mismatch detected for bidder details. Please contact support.')
          return
        }

        verifiedBidderId = String(latestBidderId)
        verifiedBidSecurityId = String(latestBidSecurityId)
        form.setFieldsValue({
          bidder_id: verifiedBidderId,
          bid_security_id: verifiedBidSecurityId
        })
      } catch (verificationError) {
        // eslint-disable-next-line no-console
        console.error('Failed to verify bidder and bid security IDs:', verificationError)
        setLoadingRefund(false)
        void message.error('Failed to validate bidder details. Please try again.')
        return
      }

      formData.append('attachment', file)
      formData.append('bailiff_assignee', form.getFieldValue('bailiff_assigned'))
      formData.append('bailiff_national_id', form.getFieldValue('bailiff_national_id_number'))
      formData.append('bailiff_phone_number', form.getFieldValue('bailiff_phone_number'))
      formData.append('property_id', form.getFieldValue('property_id'))
      formData.append('execution_case_number', form.getFieldValue('execution_case_number'))
      formData.append('bank_code', BAILIFF_REFUND_FIXED_BENEFICIARY.bank_code)
      formData.append('transaction_reference', txRef)
      formData.append('debit_account_number', '000400696575429')
      formData.append('debit_account_name', 'MINIJUST AUCTION FUNDS MAF')
      formData.append('beneficiary_name', form.getFieldValue('bailiff_assigned'))
      formData.append(
        'beneficiary_account_name',
        BAILIFF_REFUND_FIXED_BENEFICIARY.beneficiary_bank_account_name
      )
      formData.append('beneficiary_bank_name', BAILIFF_REFUND_FIXED_BENEFICIARY.beneficiary_bank_name)
      formData.append(
        'beneficiary_account_number',
        BAILIFF_REFUND_FIXED_BENEFICIARY.beneficiary_account_number
      )
      formData.append('amount', refundableAmount)
      formData.append('transaction_currency', String(form.getFieldValue('transaction_currency') ?? ''))
      formData.append(
        'reason',
        `Refund requested by ${requesterInReason} for amount ${String(amount)} RWF to ${String(
          BAILIFF_REFUND_FIXED_BENEFICIARY.beneficiary_bank_account_name
        )}. Phone: ${String(form.getFieldValue('bailiff_phone_number') ?? '')}. ` +
        `Execution case: ${String(form.getFieldValue('execution_case_number') ?? '')}. ` +
        `Property: ${String(form.getFieldValue('property_id') ?? '')}.`
      )
      formData.append('status', 'PENDING')
      formData.append('bidder_id', verifiedBidderId)
      formData.append('bid_security_id', verifiedBidSecurityId)
      formData.append('bidder_phone_number', form.getFieldValue('phone_number'))

      // Create refund request first
      try {
        const response = await InstitutionUserService.BailiffTriggerRefundRequest(formData, '')

        if (response.status === 201) {
          // Create audit log
          const generatedUuid = uuidv4()
          const auditPayload = {
            AuditLogsData: {
              action: 'INSERT',
              table_name: 'bailiff_refund_request',
              record_id: generatedUuid,
              old_data: {},
              new_data: Object.fromEntries(formData.entries()),
              created_by: fullName,
              refund_request_id: response.data?.refund_request_id ?? null
            }
          }

          try {
            await InstitutionUserService.TrackRecords(auditPayload)
          } catch (auditErr) {
            // eslint-disable-next-line no-console
            console.error('Audit log creation failed:', auditErr)
          }

          // Refund request created successfully, now open OTP modal
          setBailiffTransactionReferenceNumber(txRef)
          setLoadingRefund(false)
          setShowOTPForm(true)
          setOtpDigits(['', '', '', '', '', ''])
          setOtpValue('')
          setOtpError('')
          setCountdown(300000) // Reset countdown to 5 minutes

          // Generate OTP when modal opens
          try {
            const otpResponse = await InstitutionUserService.bailiffCreateOtpCode({
              transaction_reference: txRef,
              status: 'PENDING'
            })

            if (otpResponse.status === 200 || otpResponse.status === 201) {
              void message.success('OTP has been sent to your phone number. Please check your SMS.')
              // Focus on first input after modal opens
              setTimeout(() => {
                const firstInput = document.getElementById('otp-input-bailiff-0') as HTMLInputElement | null
                if (firstInput !== null) {
                  firstInput.focus()
                }
              }, 100)
            } else {
              void message.warning('Refund request created, but failed to generate OTP. Please contact support.')
            }
          } catch (otpErr: any) {
            // eslint-disable-next-line no-console
            console.error('OTP generation error:', otpErr)
            if (otpErr?.response?.status === 404) {
              void message.warning('OTP may have already been sent. Please check your phone.')
            } else {
              void message.warning('Refund request created, but failed to generate OTP. Please contact support.')
            }
          }
        } else {
          void message.error('Failed to create refund request.')
          setLoadingRefund(false)
        }
      } catch (error: any) {
        // eslint-disable-next-line no-console
        console.error('Refund request creation error:', error)
        if (error?.response != null) {
          const status = error.response.status
          const errorData = error.response.data

          if (status === 400) {
            const errorMessage = getFriendlyBailiffUploadErrorMessage(error)
            void message.error(errorMessage)
          } else if (status === 413) {
            void message.error('Attachment is too large. Maximum allowed size is 5MB.')
          } else if (status === 404) {
            void message.error('Transaction reference not found. Please verify and try again.')
          } else if (status === 500) {
            void message.error('Server error occurred. Please try again later.')
          } else {
            const errorMessage = (errorData?.message != null) ? String(errorData.message) : 'Failed to create refund request. Please try again.'
            void message.error(errorMessage)
          }
        } else if (error?.message === 'Network Error' || error?.code === 'ECONNABORTED') {
          void message.error('Network error. Please check your internet connection and try again.')
        } else {
          void message.error('Failed to create refund request. Please try again.')
        }
        setLoadingRefund(false)
      }
    } catch (err: any) {
      setLoadingRefund(false)
      if (err?.response?.status === 400) {
        setShowWarningAlert(true)
      } else {
        // eslint-disable-next-line no-console
        console.error('Submission error:', err)
      }
    }
  }
  return (
    <div className="w-full">
      <div className="navbar pay-bot-border navbar-background">
        <div className="flex">
          <div className="nav-logo">
            <img src={minijust_logo} alt="Logo" />
          </div>
          <div className="nav-content text-standard md:text-title">
            <div className="nav-content-header">MINIJUST - IECMS</div>
            <div>Bid Security Online Payment and Refund</div>
          </div>
        </div>
      </div>

      <div className="scrollableContent">
        {showForm && (
          // eslint-disable-next-line @typescript-eslint/no-misused-promises
          <Form
            name="normal_login"
            layout="vertical"
            className="login-form p-10"
            initialValues={{ remember: true }}
            autoComplete="off"
            /* eslint-disable-next-line @typescript-eslint/no-misused-promises */
            onFinish={onFinish}
            form={form}
          >
            <Space direction="vertical" size={5} className="w-full content-background">
              <Card className="card-border h-full ">
                {/* eslint-disable-next-line max-len */}
                <div className="font-extrabold text-title flex text-center items-center justify-center leading-10 text-gray-500 pb-2">
                  Please fill the form below for requesting refund
                </div>

                {/* Progress bar */}
                <Progress percent={Number(((currentStep / steps.length) * 100).toFixed(0))} />

                {/* Step name */}
                <div className="text-center font-semibold mt-3 mb-5">
                  Step {currentStep}: {steps[currentStep - 1].title}
                </div>
                {currentStep === 1 && (
                  <>
                    {/* eslint-disable-next-line max-len */}
                    <div className="green-color font-extrabold text-title flex text-center items-center justify-center py-5">
                      Details Verification - Bailiff Assigned To Auction and Bidder Winner Details
                    </div>
                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={4} xl={4}></Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          label="Execution Case Number"
                          name="execution_case_number"
                          rules={[
                            {
                              required: true,
                              message: 'Please enter execution case number'
                            }
                          ]}
                        >
                          <Input
                            maxLength={16}
                            placeholder="Enter Execution Case Number"
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          label="Bailiff Assigned"
                          name="bailiff_assigned"
                          rules={[{ required: true, message: 'Please enter Bailiff Assigned' }]}
                        >
                          <Input type="tel" placeholder="Enter Bailiff Assignee" disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={4} xl={4}></Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={4} xl={4}></Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          label="Bailiff's National ID Number"
                          name="bailiff_national_id_number"
                          rules={[
                            {
                              required: true,
                              message: "Please enter Bailiff's National ID Number"
                            }
                          ]}
                        >
                          <Input
                            maxLength={16}
                            placeholder="Enter Bailiff's National ID Number"
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          label="Bailiff Phone Number"
                          name="bailiff_phone_number"
                          rules={[
                            { required: true, message: 'Please enter Bailiff Phone Number' },
                            {
                              message:
                                'Bailiff Phone number should be either 4 digits or 10 digits.',
                              pattern: PHONE_PATTERN
                            }
                          ]}
                        >
                          <Input type="tel" placeholder="Enter Bailiff Phone Number" disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={4} xl={4}></Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={4} xl={4}></Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          label="Bidder's Names"
                          name="bidder_full_name"
                          rules={[
                            {
                              required: true,
                              message: "Please select Bidder's Names"
                            }
                          ]}
                        >
                          <Input placeholder="Enter Bidders Names" disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          label="Bidder's Phone Number"
                          name="phone_number"
                          rules={[
                            { required: true, message: 'Please enter Bidders Phone Number' },
                            {
                              message:
                                'Bidders Phone number should be either 4 digits or 10 digits.',
                              pattern: PHONE_PATTERN
                            }
                          ]}
                        >
                          <Input type="tel" placeholder="Enter Bidders Phone Number" disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={4} xl={4}></Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={4} xl={4}></Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          label="Bidder's National ID Number"
                          name="bidder_national_id_number"
                          rules={[
                            {
                              required: true,
                              message: "Please enter Bidder's National ID Number"
                            }
                          ]}
                        >
                          <Input
                            maxLength={16}
                            placeholder="Enter Bidder's National ID Number"
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          label="Property ID"
                          name="property_id"
                          rules={[
                            { required: true, message: 'Please enter Property ID' },
                            {
                              message: 'Property ID should be either 4 digits or 10 digits.',
                              pattern: PHONE_PATTERN
                            }
                          ]}
                        >
                          <Input type="tel" placeholder="Enter Property ID" disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={4} xl={4}></Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={4} xl={4}></Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          label="Bid Reference Number"
                          name="bidSecurityReference"
                          rules={[
                            {
                              required: true,
                              message: 'Please enter Bid Reference Number'
                            }
                          ]}
                        >
                          <Input maxLength={16} placeholder="Enter Bid Reference Number" disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          // label="PRP"
                          name="prp"
                          hidden
                          // rules={[{ required: true, message: 'PRP is required' }]}
                        >
                          <Input type="hidden" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={4} xl={4}></Col>
                    </Row>
                  </>
                )}
                {currentStep === 2 && (
                  <>
                    {/* eslint-disable-next-line max-len */}
                    <div className="green-color font-extrabold text-title flex text-center items-center justify-center py-5">
                      Provide Payment Details
                    </div>
                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={4} xl={4}></Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          label="Bid Security Paid"
                          name="amount"
                          rules={[{ required: true, message: 'Please enter Amount' }]}
                        >
                          <Input type="text" placeholder="Amount" disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          label="Currency"
                          name="transaction_currency"
                          rules={[
                            { required: true, message: 'Please provide the transaction currency' }
                          ]}
                        >
                          <Input maxLength={24} placeholder="RWF" disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={4} xl={4}></Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={4} xl={4}></Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          label="Bank Account Number"
                          name="beneficiary_account_number"
                          rules={[
                            { required: true, message: 'Please enter Bank Account Number' },
                            {
                              pattern: /^[0-9]+$/,
                              message: 'Please enter only numbers for Bank Account Number'
                            }
                          ]}
                        >
                          <Input
                            maxLength={24}
                            placeholder="Enter Bidder's Bank Account Number"
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          label="Bank Name"
                          name="beneficiary_bank_name"
                          rules={[
                            {
                              required: true,
                              message: "Please enter Bidder's Bank Name"
                            }
                          ]}
                        >
                          <Input placeholder="Beneficiary Account Name" disabled />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={4} xl={4}></Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          label="Bank Account Name"
                          name="beneficiary_bank_account_name"
                          rules={[{ required: true, message: 'Please enter Bank Account Name' }]}
                        >
                          <Input type="text" placeholder="Enter Bank Account Name" disabled />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={4} xl={4}>
                        <Form.Item
                          // label="Bank Code"
                          name="bank_code"
                          hidden
                          rules={[
                            {
                              required: true,
                              message: 'Bank Code not Available'
                            }
                          ]}
                        >
                          <Input type="hidden" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={4} xl={4}>
                        <Form.Item
                          label="Bid Security Payment Date"
                          name="bid_payment_date"
                          rules={[
                            {
                              required: true,
                              message: 'Payment Date not Available'
                            }
                          ]}
                        >
                          {/* eslint-disable-next-line max-len */}
                          <Input placeholder="Payment Date" disabled />
                        </Form.Item>
                      </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                      <Col xs={24} md={4} xl={4}></Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          // label=" Bidder "
                          name="bidder_id"
                          hidden
                        >
                          <Input type="hidden" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={8} xl={8}>
                        <Form.Item
                          // label="Bid security"
                          name="bid_security_id"
                          hidden
                        >
                          <Input type="hidden" />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={4} xl={4}></Col>
                    </Row>
                  </>
                )}

                {currentStep === 3 && (
                  <>
                    {/* eslint-disable-next-line max-len */}
                    <div className="green-color font-extrabold text-title flex text-center items-center justify-center py-5">
                      Attachments
                    </div>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                      <Row gutter={[16, 16]}>
                        <Col xs={24} md={4} xl={4}></Col>
                        <Col xs={24} md={16} xl={16}>
                          <Form.Item
                            label="Upload a PDF bank slip confirming that 95% was paid to the bailiff account."
                            name="attachment"
                            rules={[
                              {
                                required: true,
                                message: 'Please attach a PDF slip'
                              }
                            ]}
                            valuePropName="fileList"
                            getValueFromEvent={(e) => e?.fileList}
                          >
                            <Upload
                              accept=".pdf"
                              beforeUpload={() => false}
                              onChange={handleFileChange}
                              fileList={fileList}
                              maxCount={1}
                            >
                              <Button icon={<UploadOutlined />}>Upload PDF</Button>
                            </Upload>
                          </Form.Item>
                        </Col>
                      </Row>
                    </div>
                    <Row gutter={[16, 16]}>
                      <Row gutter={[16, 16]}>
                        <Col xs={24} md={4} xl={4}></Col>
                        <Col xs={24} md={16} xl={16}>
                          <Form.Item name="declaration" rules={[{ required: false }]}>
                            <Checkbox
                              onChange={(e) => {
                                setDeclarationChecked(e.target.checked)
                              }}
                            >
                              {/* eslint-disable-next-line max-len */}
                              I, <b>{form.getFieldValue('bailiff_assigned')}</b>, hereby declare
                              that the provided information about{' '}
                              <b>Account Number, Bank Account Name and Bank Name</b> are true,
                              accurate and complete.
                            </Checkbox>
                          </Form.Item>
                        </Col>
                        <Col xs={24} md={4} xl={4}></Col>
                      </Row>
                      <Row justify="center" align="middle" style={{ height: '100%' }}>
                        <Col xs={24} md={24} xl={24}>
                          {showWarningAlert2 && (
                            <Modal
                              visible={showWarningAlert2}
                              onCancel={() => {
                                setShowWarningAlert2(false)
                              }}
                              footer={null}
                              centered
                            >
                              <Alert
                                message="Informational Notes"
                                /* eslint-disable-next-line @typescript-eslint/restrict-template-expressions */
                                description={`Refund can only be triggered for payments starting from ${targetPaymentDateValue}. Any assistance, please contact us at iecms-support@minijust.gov.rw`}
                                type="error"
                                showIcon
                                style={{
                                  width: '100%'
                                }} // Set alert background color
                                onClose={() => {
                                  setShowWarningAlert2(false)
                                }}
                              />
                            </Modal>
                          )}
                        </Col>
                      </Row>
                      <Row justify="center" align="middle" style={{ height: '100%' }}>
                        <Col xs={24} md={24} xl={24}>
                          {showDeclarationAlert && (
                            <Modal
                              visible={showDeclarationAlert}
                              onCancel={() => {
                                setShowDeclarationAlert(false)
                              }}
                              footer={null}
                              centered
                            >
                              <Alert
                                message="Warning"
                                description="Please accept the declaration before submitting."
                                type="warning"
                                showIcon
                                style={{
                                  width: '100%'
                                }} // Set alert background color
                                onClose={() => {
                                  setShowDeclarationAlert(false)
                                }}
                              />
                            </Modal>
                          )}
                        </Col>
                      </Row>
                      <Row justify="center" align="middle" style={{ height: '100%' }}>
                        <Col xs={24} md={24} xl={24}>
                          {showWarningAlert && (
                            <Modal
                              visible={showWarningAlert}
                              onCancel={() => {
                                setShowWarningAlert(false)
                              }}
                              footer={null}
                              centered
                            >
                              <Alert
                                message="Informational Notes"
                                /* eslint-disable-next-line @typescript-eslint/restrict-template-expressions */
                                description={`Refund Request already exists with the same Transaction Reference Number: ${bidderBidReferenceNumber}`}
                                type="info"
                                showIcon
                                style={{
                                  width: '100%'
                                }}
                                onClose={() => {
                                  setShowWarningAlert(false)
                                }}
                              />
                            </Modal>
                          )}
                        </Col>
                      </Row>
                      <Row justify="center" align="middle" style={{ height: '100%' }}>
                        <Col xs={24} md={24} xl={24}>
                          {showSuccessAlert && (
                            <Modal
                              visible={showSuccessAlert}
                              onCancel={() => {
                                setShowSuccessAlert(false)
                              }}
                              footer={null}
                              centered
                            >
                              <Alert
                                message="Informational Notes"
                                /* eslint-disable-next-line @typescript-eslint/restrict-template-expressions */
                                description="Refund Request Submitted. Waiting to be Refunded..."
                                type="info"
                                showIcon
                                style={{
                                  width: '100%'
                                }} // Set alert background color
                                onClose={() => {
                                  setShowSuccessAlert(false)
                                }}
                              />
                            </Modal>
                          )}
                        </Col>
                      </Row>
                    </Row>
                  </>
                )}

                {/* Buttons for navigating between steps */}
                <Row gutter={[16, 16]} justify="center">
                  <Col xs={24} md={8} xl={8} className="text-right">
                    {currentStep > 1 && <Button onClick={prevStep}>Previous</Button>}
                  </Col>
                  <Col xs={24} md={8} xl={8} className="text-left">
                    {currentStep < 3 && (
                      <Button type="primary" onClick={nextStep}>
                        Next
                      </Button>
                    )}
                    {currentStep === 3 && (
                      <Button type="primary" htmlType="submit">
                        {isEdit ? 'Update' : 'Continue'}
                      </Button>
                      // <Button type="primary" htmlType="submit">Submit</Button>
                    )}
                  </Col>
                  <Col xs={24} md={8} xl={8}></Col>
                </Row>
              </Card>
            </Space>
          </Form>
        )}
        {/* Step 3: Render OTP form conditionally */}
        <Modal
          title={
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <span style={{ fontSize: '24px' }}>🔐</span>
              <span style={{ fontSize: '18px', fontWeight: '600' }}>Enter Verification Code</span>
            </div>
          }
          visible={showOTPForm && isFormSubmitted && isFormValidated && declarationChecked}
          onCancel={handleOTPFormCancel}
          footer={[
            <Button key="cancel" onClick={handleOTPFormCancel}>
              Cancel
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={() => { void handleOTPSubmit() }}
              disabled={otpDigits.join('').length !== 6}
              loading={loadingRefund}
            >
              Verify & Submit
            </Button>
          ]}
          className="custom-modal"
          keyboard={false}
          maskClosable={false}
          width={500}
          style={{ borderRadius: '12px' }}
        >
          <div style={{ padding: '8px 0' }}>
            <div style={{ textAlign: 'center', marginBottom: '24px' }}>
              <p style={{ margin: '0 0 8px 0', color: '#666', fontSize: '14px' }}>
                We sent a verification code to your phone number ending with{' '}
                <strong style={{ color: '#1890ff' }}>
                  {phone_number.length > 2 ? `****${phone_number.slice(-2)}` : '******'}
                </strong>
                {bailiffEmail !== '' && (
                  <span> or check your email: <strong style={{ color: '#1890ff' }}>{bailiffEmail}</strong></span>
                )}
              </p>
              <p style={{ margin: '0', color: '#999', fontSize: '12px' }}>
                Please enter the 6-digit code below
              </p>
            </div>

            {otpError !== '' && (
              <Alert
                message={otpError}
                type="error"
                showIcon
                style={{ marginBottom: '20px' }}
                closable
                onClose={() => { setOtpError('') }}
              />
            )}

            <Form.Item
              name="otp"
              rules={[{ required: true, message: 'Please enter the complete OTP code' }]}
              style={{ marginBottom: '20px' }}
            >
              <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', marginBottom: '8px' }}>
                {otpDigits.map((digit, idx) => (
                  <Input
                    key={idx}
                    id={`otp-input-bailiff-${idx}`}
                    value={digit}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength={1}
                    onChange={(e) => { handleOtpChange(idx, e.target.value) }}
                    onKeyDown={(e) => { handleOtpKeyDown(idx, e) }}
                    onPaste={(e) => { handleOtpPaste(e) }}
                    style={{
                      width: '48px',
                      height: '56px',
                      textAlign: 'center',
                      fontSize: '24px',
                      fontWeight: '600',
                      borderRadius: '8px',
                      borderColor: (otpError !== '') ? '#ff4d4f' : '#d9d9d9',
                      borderWidth: '2px',
                      transition: 'all 0.2s'
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = '#1890ff'
                      e.target.style.boxShadow = '0 0 0 2px rgba(24, 144, 255, 0.2)'
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = (otpError !== '') ? '#ff4d4f' : '#d9d9d9'
                      e.target.style.boxShadow = 'none'
                    }}
                  />
                ))}
              </div>
            </Form.Item>

            <div style={{ textAlign: 'center', marginTop: '24px' }}>
              <p style={{ margin: '0 0 12px 0', color: '#666', fontSize: '13px' }}>
                Code expires in{' '}
                <code
                  style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: countdown < 60000 ? '#ff4d4f' : '#1890ff',
                    background: '#f0f0f0',
                    padding: '4px 8px',
                    borderRadius: '4px'
                  }}
                >
                  {moment(countdown).format('mm:ss')}
                </code>
              </p>
              <div style={{ marginTop: '16px' }}>
                {countdown === 0
                  ? (
                      <Button
                        type="link"
                        onClick={() => { void handleResendOTP() }}
                        style={{ padding: '0', fontWeight: '600' }}
                      >
                        Resend Code
                      </Button>
                    )
                  : (
                      <p style={{ margin: '0', color: '#999', fontSize: '12px' }}>
                        Didn&apos;t receive the code?{' '}
                        <Button
                          type="link"
                          disabled
                          style={{ padding: '0', fontSize: '12px' }}
                        >
                          Resend in {moment(countdown).format('mm:ss')}
                        </Button>
                      </p>
                    )}
              </div>
            </div>

            <div
              style={{
                marginTop: '20px',
                padding: '12px',
                background: '#f0f9ff',
                borderRadius: '8px',
                border: '1px solid #bae7ff'
              }}
            >
              <p style={{ margin: '0', fontSize: '12px', color: '#666', lineHeight: '1.5' }}>
                <strong>💡 Tip:</strong> You can paste the entire 6-digit code at once, or enter each digit
                individually.
              </p>
            </div>
          </div>
        </Modal>

        <Modal
          title="Notification"
          visible={showBankCodeModal}
          onCancel={() => {
            setShowBankCodeModal(false)
            setShowCancelMessage(true)
          }}
          footer={null}
          centered
        >
          {isVisible && (
            <>
              <p
                style={{
                  fontWeight: 'bold',
                  color: '#333'
                }}
              >
                Please wait while fetching...
              </p>
              <hr
                style={{
                  borderTop: '2px solid #ccc',
                  margin: '10px 0'
                }}
              />
              <p
                style={{
                  fontWeight: 'bold',
                  fontSize: 'var(--base-font-size)',
                  color: '#333'
                }}
              >
                Mutegereze gato mu gihe turi kureba amakuru ajyanjye ni ingwate ya cyamunara muri
                gusaba...
              </p>
            </>
          )}
          {showHello && (
            <p>
              <b>You can not proceed with the refund request.</b>
              <br></br>
              Some information is missing.
              <br></br> <b>Note:</b> Contact Us on <b>iecms-support@minijust.gov.rw</b>
              <br></br>
              <hr
                style={{
                  border: '1px solid #ccc',
                  margin: '20px 0',
                  width: '80%',
                  backgroundColor: '#ccc'
                }}
              ></hr>
              Igikorwa cyo Gusaba Ingwate y Ipiganwa Ntigishoboye Gukomeza. NB: Ku bindi bisobanuro
              watwandikira kuri <b>iecms-support@minijust.gov.rw</b>
            </p>
          )}
        </Modal>
        <Modal
          title={codeBank === '040' ? 'Bid Security Refund Amount' : 'Bank Transfer Charges'}
          visible={
            showBankTransferChargeModal &&
            bailiffId !== null &&
            form.getFieldValue('bailiff_assigned') !== null
          }
          onCancel={() => {
            setShowBankTransferChargeModal(false)
            setShowCancelMessage(true)
          }}
          footer={[
            <Button
              key="cancel"
              onClick={() => {
                setShowBankTransferChargeModal(false)
                setShowCancelMessage(true)
              }}
            >
              Cancel
            </Button>,
            <Button type="primary" key="ok" onClick={handleAgree}>
              I Agree
            </Button>
          ]}
          keyboard={false}
          maskClosable={false}
          className="custom-modal"
        >
          <p>
            {/* eslint-disable-next-line max-len */}
            You will be charged{' '}
            <strong>
              {codeBank !== '040' ? '1,000 Rwf (BK to other Banks).' : '0 Rwf (BK to BK)'}
            </strong>
            .
          </p>

          <p>
            {/* eslint-disable-next-line max-len */}
            Total bid Security Paid:{' '}
            <strong>{parseInt(String(paymentAmount)).toLocaleString()} Rwf </strong>
          </p>

          <p>
            Amount Received in Your Account after Transfer:{' '}
            <strong>
              {/* eslint-disable-next-line max-len */}
              {parseInt(
                String(Number(paymentAmount) - (codeBank !== '040' ? 1000 : 0))
              ).toLocaleString()}{' '}
              Rwf
            </strong>
          </p>
        </Modal>
        {showCancelMessage && (
          <div className="cancel-message">
            <div className="separator"></div>
            <p>
              <h3>Thank you for using our services.</h3>
            </p>
            <div className="separator"></div>
            <p>
              For any other support, please contact us on
              <span>
                <strong>iecms-support@minijust.gov.rw</strong>
              </span>
              .
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default BaillifRefundRequest
